// Photos used on public pages, with the credit their licences require (all from Wikimedia Commons).
export interface Photo { url: string; credit: string; source: string }

export const HERO_PHOTOS: Record<'port' | 'mine' | 'bess', Photo> = {
  "port": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/58/The_Port_of_Port_Hedland%2C_2023%2C_01.jpg/960px-The_Port_of_Port_Hedland%2C_2023%2C_01.jpg",
    "credit": "Kgbo · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:The_Port_of_Port_Hedland,_2023,_01.jpg"
  },
  "mine": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a5/Open_pit_of_the_Greenbushes_mine%2C_January_2023_07.jpg/960px-Open_pit_of_the_Greenbushes_mine%2C_January_2023_07.jpg",
    "credit": "Calistemon · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Open_pit_of_the_Greenbushes_mine,_January_2023_07.jpg"
  },
  "bess": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c6/Tesvolt_battery_energy_storage_system_Rheineck.jpg/960px-Tesvolt_battery_energy_storage_system_Rheineck.jpg",
    "credit": "Kecko from Eastern Switzerland · CC BY 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Tesvolt_battery_energy_storage_system_Rheineck.jpg"
  }
};

export const PRODUCT_PHOTOS: Record<string, Photo> = {
  "spodumene_sc6": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a0/Spodumene_%28GeoDIL_number_-_400%29.jpg/960px-Spodumene_%28GeoDIL_number_-_400%29.jpg",
    "credit": "Shannon Heinle · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Spodumene_(GeoDIL_number_-_400).jpg"
  },
  "lioh_battery": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/88/LiOH_2009.jpg/960px-LiOH_2009.jpg",
    "credit": "Xavier13540 · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:LiOH_2009.jpg"
  },
  "li2co3_battery": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/f/f4/Lithium_carbonate.jpg",
    "credit": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_carbonate.jpg"
  },
  "nickel_sulphate": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b2/Nickel%28II%29-sulfate-hexahydrate-sample.jpg/960px-Nickel%28II%29-sulfate-hexahydrate-sample.jpg",
    "credit": "Benjah-bmm27 · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Nickel(II)-sulfate-hexahydrate-sample.jpg"
  },
  "cobalt_sulphate": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7c/Cobalt%28II%29_sulfate.jpg/960px-Cobalt%28II%29_sulfate.jpg",
    "credit": "Adam Rędzikowski · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Cobalt(II)_sulfate.jpg"
  },
  "graphite_flake": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a9/Graphite_%28Ceylon%29_36.jpg/960px-Graphite_%28Ceylon%29_36.jpg",
    "credit": "James St. John · CC BY 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Graphite_(Ceylon)_36.jpg"
  },
  "cam_nmc811": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/d6/NCM811-micro_roses.jpg/960px-NCM811-micro_roses.jpg",
    "credit": "Altynay.Kaiyrgali · CC BY 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:NCM811-micro_roses.jpg"
  },
  "battery_cells_prismatic": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b6/Lithium_Iron_Phosphate_LiFePO4_Cells_700_Ah_Amp_Hours_3.25_Volts_-_7.jpg/960px-Lithium_Iron_Phosphate_LiFePO4_Cells_700_Ah_Amp_Hours_3.25_Volts_-_7.jpg",
    "credit": "Yo-Co-Man · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_Iron_Phosphate_LiFePO4_Cells_700_Ah_Amp_Hours_3.25_Volts_-_7.jpg"
  },
  "battery_packs_ev_bess": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/d6/Air-cooled_industrial_and_commercial_battery_energy_storage_system.jpg/960px-Air-cooled_industrial_and_commercial_battery_energy_storage_system.jpg",
    "credit": "Yan lance · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Air-cooled_industrial_and_commercial_battery_energy_storage_system.jpg"
  }
};
